module.exports = __webpack_public_path__ + "assets/img/logAudit-module5-8.3aaeae6f.jpg";